import script from "./Clubs.vue?vue&type=script&setup=true&lang=js"
export * from "./Clubs.vue?vue&type=script&setup=true&lang=js"

import "./Clubs.vue?vue&type=style&index=0&id=e1b232fa&lang=scss"

const __exports__ = script;

export default __exports__